import { ChangeEvent, useEffect, useState } from 'react';
import { Alert, AlertColor, Box, Button, Card, CardContent, Checkbox, CircularProgress, FormControl, FormControlLabel, FormGroup, Grid, Icon, InputLabel, ListItemText, MenuItem, OutlinedInput, Paper, Select, TextField, Typography } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useVForm } from 'shared/forms';
import { FerramentasDeDetalhe, InputError, ConfirmacaoModal } from 'shared/components';
import { LayoutBaseDePagina } from 'shared/layouts';
import { OrgFornecedoraService } from 'shared/services/orgFornecedora/orgFornecedoraService';
import { ICreateOrgFornecedora, IListagemFornecedora, IListagemOrgFornecedora, IDetalheOrgFornecedora, InicitalCreateOrgFornecedora, IListagemCanal, IResponseDetalheOrgFornecedora, IUpdateStatus } from 'shared/types';
import { t } from 'i18next';
import { useHasPermissionAcao } from 'shared/hooks';
import { IKeyValue, dateToLocalISO, listagemCanalToIKeyValue, listagemOrgToIKeyValue } from 'shared/utils';
import { CanaisService } from 'shared/services/canais/canaisService';
import { FornecedorasService } from 'shared/services/fornecedoras/fornecedorasService';
import { OrganizationsService } from 'shared/services/organizations/organizationsService';
import { EnvioService } from 'shared/services/envio/EnvioService';
import { useSelectedOrganization } from 'shared/store/organization';
import { AlteracaoStatusModal } from 'shared/components/CustomFlowNodes/AlteracaoStatusModal';
import { AlteracaoStatusModalOrgForn } from './AlteracaoStatusModalOrgForn';


const validationSchema = yup.object({
  IdFornecedora: yup.number().moreThan(0),
  IdOrganizacao: yup.number(),
  IdCanal: yup.number(),
  Fornecedora:  yup.string(),
  Organizacao:  yup.string(),
  Canal:  yup.string(),
  usuariodeConexao: yup.string(),
  Prioridade: yup.number(),
  IdUsuarioInclusao: yup.number(),
  senha: yup.string(),
  ConfirmarSenha: yup.string(),
  NomeUsuarioInclusao: yup.string(),
  DhUpd: yup.date(),
  UsuarioIdUpd: yup.number(),
  TenantIddeConexao: yup.string(),
  NmScoreInativos: yup.string(),
  CdScoreInativos: yup.string(),
  NmScoreAtivos: yup.string(),
  CdScoreAtivos: yup.string(),
  Status: yup.string(),
  DataInclusao: yup.date(),
  EmailReply: yup.string(),
  EmailRemetente: yup.string(),
  NomeRemetente: yup.string(),
});

export const DetalheOrgFornecedora: React.FC = () => {
  const org = useSelectedOrganization();
  // const { id = 'novo' } = useParams<'id'>();
  const { Fornecedora } = useParams<'Fornecedora'>();
  const { Canal } = useParams<'Canal'>();
  const novo = isNaN(Number(Fornecedora)) ? true : false;

  const navigate = useNavigate();

  const hasPermitionCreate = useHasPermissionAcao('fornecedora', 'CRE');
  const hasPermitionUpdate = useHasPermissionAcao('fornecedora', 'UPD');

  const [alert, setAlert] = useState<null | { text: string; type: AlertColor }>(null);
  const { formRef, save, isSaveAndClose } = useVForm();

  const { register, handleSubmit, reset, watch, formState: { errors }, } = useForm({
    resolver: yupResolver(validationSchema),
    reValidateMode: 'onBlur'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isStatus, setIsStatus] = useState(false);

  const [openAlterarStatus,setOpenAlterarStatus] = useState(false);
  const [statusAlteracao, setStatusAlteracao] = useState('');

  const [orgForn, setorgForn] = useState({
    StatusOrgForn: '',
  });

  const [isEngajado, setEngajado] = useState(false);
  const [isNaoEngajado, setNaoEngajado] = useState(false);
  
  const [titleConfirmacao, setTitleConfirmacao] = useState('');
  const [openConfirmacao, setOpenConfirmacao] = useState(false);
  const [messageConfirmacao, setMessageConfirmacao] = useState('');
  const [OrgFornecedor, setOrgFornecedor] = useState<IDetalheOrgFornecedora>();


  const [listKeyValueCanal, setListKeyValueCanal] = useState<IKeyValue[]>([]);
  const [listKeyValueOrg, setListKeyValueOrg] = useState<IKeyValue[]>([]);

  const [listKeyValueFornecedora, setListKeyValueFornecedora] = useState<IListagemFornecedora[]>([]);

  const [isLoadingOrg, setIsLoadingOrg] = useState(true);
  const [isLoadingCanal, setIsLoadingCanal] = useState(true);
  const [isLoadingFornecedora, setisLoadingFornecedora] = useState(true);

  const selectTipo = watch('IdCanal');
  const selectFornedora = watch('IdFornecedora');

  const listKeyValueStatus: IKeyValue[] = [
    {
      key: 'A',
      value: 'Ativo'
    }, {
      key: 'I',
      value: 'Inativo'
    },];

  const [stateSnack, setStateSnack] = useState({
    open: false,
    severity: 'success',
    message: '',
  });

  useEffect(() => {
    setAlert(null);
    if (!novo) {
      setIsLoading(true);
      OrgFornecedoraService.getByIds(Number(org?.CodigoOrganizacao), Number(Fornecedora))
        .then((result) => {

          if (result instanceof Error) {
            setAlert({
              text: result.message,
              type: 'error',
            });
            navigate('/fornecedora/listagem');
          } else {
            setOrgFornecedor(result);
            setStatusAlteracao(result.Status);
            setorgForn({StatusOrgForn: result.Status});
            reset(result);
          }
          setIsLoading(false);
        });
    }
    else {
      reset(InicitalCreateOrgFornecedora);
    }

  }, [Fornecedora]);

  useEffect(() => {
    setIsLoadingCanal(true);
    CanaisService.getAll()
      .then((result) => {
        setIsLoadingCanal(false);
        if (result instanceof Error) {
          setStateSnack({ open: true, severity: 'error', message: `Ocorreu o seguinte erro: ${result.message}` });
        } else {
          setListKeyValueCanal(listagemCanalToIKeyValue(result));
          
          
        }
      });

    setisLoadingFornecedora(true);
    FornecedorasService.get()
      .then((result) => {
        setisLoadingFornecedora(false);
        if (result instanceof Error) {
          setStateSnack({ open: true, severity: 'error', message: `Ocorreu o seguinte erro: ${result.message}` });
        } else {
          setListKeyValueFornecedora(result);
        }
      });

  }, []);


  const handleDelete = () => {
    setTitleConfirmacao(t('components.actions.apagar'));
    setMessageConfirmacao(t('messages.organizationSeletion.exclusion') + org + '?');
    setOpenConfirmacao(true);
    console.log('handleDelete');
  };

  const confirmDelete = () => {
    setAlert(null);
    OrgFornecedoraService.deleteD(String(org))
      .then(result => {
        if (result instanceof Error) {
          setAlert({
            text: result.message,
            type: 'error',
          });
          setOpenConfirmacao(false);
        } else {
          setAlert({
            text: 'Registro apagado com sucesso!',
            type: 'error',
          });
          navigate('/fornecedora/listagem');
        }
      })
      .catch(reason => {
        setAlert({
          text: reason,
          type: 'error',
        });
        setOpenConfirmacao(false);
      });
  };

  const alterarStatus = () => {
    setOpenAlterarStatus(true);
  };
  
  const handleChangeEngajados = (e:any) => {
    setEngajado(e.target.checked);
  };

  const handleChangeNaoEngajados = (e:any) => {
    setNaoEngajado(e.target.checked);
  };

  const handleAlterarStatus = () => {
    setAlert(null);
    const data : IUpdateStatus = {idFornecedora: Number(Fornecedora), status: statusAlteracao, idCanal: Number(Canal) };
    OrgFornecedoraService.updateStatus(Number(org?.CodigoOrganizacao), data)
      .then(result => {
        if (result instanceof Error) {
          setAlert({
            text: 'Não é posssível alterar o status para Ativo porque ainda não existe a Configuração de Envio.',
            type: 'warning',
          });
          setOpenAlterarStatus(false);
        } else {
          setIsStatus(true);
          setOpenAlterarStatus(false);
          setorgForn({StatusOrgForn: statusAlteracao});
          setAlert({
            text: 'Status Alterado com sucesso!',
            type: 'success',
          });
        }
      })
      .catch(reason => {
        setAlert({
          text: reason,
          type: 'error',
        });
        setOpenAlterarStatus(false);
      });
  };

  const onSubmit = async (data: ICreateOrgFornecedora) => {

    setAlert(null);
    setIsSubmitting(true);
    if (novo) {
      OrgFornecedoraService
        .create(Number(org?.CodigoOrganizacao), data)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            setAlert({
              text: result.message,
              type: 'error',
            });
          } else {
            if (isSaveAndClose()) {
              navigate('/fornecedora/listagem');
            } setAlert({
              text: t('messages.success.incluido'),
              type: 'success',
            });
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });

    } else {
      OrgFornecedoraService
        .update(Number(org?.CodigoOrganizacao), data)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setAlert({
              text: result.message,
              type: 'error',
            });
          } else {
            if (isSaveAndClose()) {
              navigate('/fornecedora/listagem');
            }
            setAlert({
              text: t('messages.success.alterado'),
              type: 'success',
            });
            setIsStatus(false);

          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });

    }
    
  };
  console.log(listKeyValueFornecedora);
  return (
    <LayoutBaseDePagina

      titulo={novo ? t('pages.orgFornecedora.newOrgfornecedora') : hasPermitionUpdate ? t('pages.orgFornecedora.changeOrgfornecedora') : t('pages.orgFornecedora.viewOrgfornecedora')}

      barraDeFerramentas={!(isLoading || isSubmitting) && (
        <FerramentasDeDetalhe
          idForm='formDetalheDeOrgFornecedora'

          mostrarBotaoNovo={novo || hasPermitionCreate}
          mostrarBotaoApagar={false}
          mostrarBotaoSalvar={novo || hasPermitionUpdate}
          
          mostrarBotaoAlteraStatus={hasPermitionUpdate}
          handleAlterarStatus={alterarStatus}

          aoClicarEmSalvar={save}          
          aoClicarEmVoltar={() => navigate('/fornecedora/listagem')}
          aoClicarEmApagar={() => handleDelete()}
          aoClicarEmNovo={() => navigate('/org/fornecedora/detalhe/')}



        />


      )
      }
    >
      <Box ref={formRef} id='formDetalheDeOrgFornecedora' component="form" display="flex" autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined" width='100%' >

          <Card >
            <CardContent sx={{ padding: 0 }} >
              <div>
                {alert ? (
                  <>
                    <Grid item xs={12} paddingX={2}>
                      <Alert severity={alert.type} onClose={() => setAlert(null)} sx={{ marginTop: '1rem', marginBottom: '0' }}>
                        {alert.text}
                      </Alert>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} component={Typography} paddingX={2}>

                  </Grid>
                )}
                <Grid container  >
                  <Grid item xs={6} paddingX={2}>
                    <FormControl fullWidth sx={{ marginTop: '1rem', marginBottom: '0' }}>
                      <InputLabel id='label-select-tipo'>{`${t('pages.orgFornecedora.Canal')} *`}</InputLabel>
                      <Select
                        disabled={isSubmitting || isLoading || !novo}
                        error={errors?.Canal?.type ? true : false}
                        labelId='label-select-tipo'
                        id='IdCanal'

                        input={<OutlinedInput label={`${t('pages.orgFornecedora.Canal')} *`} />}
                        {...register('IdCanal')}
                        value={selectTipo || Canal || ''}

                      >
                        <MenuItem value=''>
                          <ListItemText primary='' />
                        </MenuItem>
                        {listKeyValueCanal.map((item) => (
                          <MenuItem key={item.key} value={item.key} >
                            <ListItemText primary={item.value} sx={{ margin: '0' }} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors?.Canal?.type && <InputError type={errors.Canal.type} field='Canal' />}

                  </Grid>

                  <Grid item xs={6} paddingX={2}>
                    <FormControl fullWidth sx={{ marginTop: '1rem', marginBottom: '0' }}>
                      <InputLabel id='label-select-tipo'>{`${t('pages.orgFornecedora.Fornecedora')} *`}</InputLabel>
                      <Select
                        disabled={isSubmitting || isLoading || !novo}
                        error={errors?.Fornecedora?.type ? true : false}
                        labelId='label-select-tipo'
                        id='Fornecedora'

                        input={<OutlinedInput label={`${t('pages.orgFornecedora.Fornecedora')} *`} />}
                        {...register('IdFornecedora')}
                        value={selectFornedora || Fornecedora || ''}

                      >
                        <MenuItem value=''>
                          <ListItemText primary='' />
                        </MenuItem>
                        {listKeyValueFornecedora?.filter((item) => item.IdCanal === Number(selectTipo || Canal)).map((item) => (
                          <MenuItem key={item.IdFornecedora} value={item.IdFornecedora} >
                            <ListItemText style={{ overflow: 'hidden' }} primary={item.NomeFornecedora} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors?.Fornecedora?.type && <InputError type={errors.Fornecedora.type} field='Fornecedora' />}

                  </Grid>


                  <Grid item xs={6} paddingX={2}>
                    <TextField
                      error={errors?.UsuariodeConexao?.type ? true : false}
                      fullWidth
                      disabled={isSubmitting || isLoading || (!hasPermitionUpdate && novo)}
                      id='UsuariodeConexao'
                      type='text'
                      label={`${t('pages.orgFornecedora.UsuariodeConexao')} *`}
                      {...register('UsuariodeConexao')}
                      sx={{ marginTop: '1rem', marginBottom: '0' }}
                      inputProps={{ maxLength: 15 }}
                    />
                    {errors?.UsuariodeConexao?.type && <InputError type={errors.UsuariodeConexao.type} field='UsuariodeConexao' />}
                  </Grid>

                  {
                    (selectTipo === '2' && selectFornedora === 3) || (Canal === '2' && Fornecedora === '3') ||
                    (selectTipo === '6' && selectFornedora === 9) || (Canal === '6' && Fornecedora === '9') ?
                      <Grid item xs={6} paddingX={2}>
                        <TextField
                          error={errors?.TenantIddeConexao?.type ? true : false}
                          fullWidth
                          disabled={isSubmitting || isLoading || (!hasPermitionUpdate && novo)}
                          id='TenantIddeConexao'
                          type='text'
                          label={`${t('pages.orgFornecedora.TenantIddeConexao')} *`}
                          {...register('TenantIddeConexao')}
                          sx={{ marginTop: '1rem', marginBottom: '0' }}
                          inputProps={{ maxLength: 10 }}
                        />
                        {errors?.TenantIddeConexao?.type && <InputError type={errors.TenantIddeConexao.type} field='TenantIddeConexao' />}
                      </Grid>
                      :
                      ''
                  }

                  {
                    (selectTipo === '2' && selectFornedora === 11) || (Canal === '2' && Fornecedora === '11') ||
                    (selectTipo === '2' && selectFornedora === 12) || (Canal === '2' && Fornecedora === '12') ||
                    (selectTipo === '2' && selectFornedora === 14) || (Canal === '2' && Fornecedora === '14') ||
                    (selectTipo === '2' && selectFornedora === 15) || (Canal === '2' && Fornecedora === '15') || 
                    (selectTipo === '2' && selectFornedora === 7) || (Canal === '2' && Fornecedora === '7') ?
                      <>

                        <Grid item xs={6} paddingX={2}>
                          <TextField
                            error={errors?.NomeRemetente?.type ? true : false}
                            fullWidth
                            disabled={isSubmitting || isLoading || (!hasPermitionUpdate && novo)}
                            id='NomeRemetente'
                            type='text'
                            label='Nome Remetente'
                            {...register('NomeRemetente')}
                            sx={{ marginTop: '1rem', marginBottom: '0' }}
                          />
                          {errors?.NomeRemetente?.type && <InputError type={errors.NomeRemetente.type} field='NomeRemetente' />}
                        </Grid>

                        <Grid item xs={6} paddingX={2}>
                          <TextField
                            error={errors?.EmailRemetente?.type ? true : false}
                            fullWidth
                            disabled={isSubmitting || isLoading || (!hasPermitionUpdate && novo)}
                            id='EmailRemetente'
                            type='text'
                            label='Email Remetente'
                            {...register('EmailRemetente')}
                            sx={{ marginTop: '1rem', marginBottom: '0' }}
                          />
                          {errors?.EmailRemetente?.type && <InputError type={errors.EmailRemetente.type} field='EmailRemetente' />}
                        </Grid>

                        <Grid item xs={6} paddingX={2}>
                          <TextField
                            error={errors?.EmailReply?.type ? true : false}
                            fullWidth
                            disabled={isSubmitting || isLoading || (!hasPermitionUpdate && novo)}
                            id='EmailReply'
                            type='text'
                            label='Email Reply'
                            {...register('EmailReply')}
                            sx={{ marginTop: '1rem', marginBottom: '0' }}
                          />
                          {errors?.EmailReply?.type && <InputError type={errors.EmailReply.type} field='EmailReply' />}
                        </Grid>
                      </>
                      :
                      ''


                  }

                  <Grid item xs={6} paddingX={2}>
                    <TextField
                      error={errors?.Senha?.type ? true : false}
                      fullWidth
                      disabled={isSubmitting || isLoading || (!hasPermitionUpdate && novo)}
                      id='Senha'
                      type='password'
                      label={`${t('pages.orgFornecedora.Senha')} *`}
                      {...register('Senha')}
                      sx={{ marginTop: '1rem', marginBottom: '0' }}
                      inputProps={{ maxLength: 10 }}
                    />
                    {errors?.Senha?.type && <InputError type={errors.Senha.type} field='Senha' />}
                  </Grid>
                  <Grid item xs={6} paddingX={2}>
                    <TextField
                      error={errors?.ConfirmarSenha?.type ? true : false}
                      fullWidth
                      disabled={isSubmitting || isLoading || (!hasPermitionUpdate && novo)}
                      id='ConfirmarSenha'
                      type='password'
                      label={`${t('pages.orgFornecedora.ConfirmarSenha')} *`}
                      {...register('ConfirmarSenha')}
                      sx={{ marginTop: '1rem', marginBottom: '0' }}
                      inputProps={{ maxLength: 10 }}
                    />
                    {errors?.ConfirmarSenha?.type && <InputError type={errors.ConfirmarSenha.type} field='ConfirmarSenha' />}
                  </Grid>

                </Grid>

              </div>
            </CardContent>
          </Card>


          {
            (selectTipo === '2' && selectFornedora === 7) || (Canal === '2' && Fornecedora === '7') ?
              <Card>
                <CardContent sx={{padding: 2}}>
                  <FormGroup>
                    <FormControlLabel control={<Checkbox checked={isEngajado} onChange={(e) => handleChangeEngajados(e)}/>} label="Engajados" />
                    <Grid item xs={6} width={300}>
                      <TextField
                        error={errors?.CdScoreAtivos?.type ? true : false}
                        fullWidth
                        disabled={!isEngajado || isSubmitting || isLoading || (!hasPermitionUpdate && novo)}
                        id='CdScoreAtivos'
                        type='text'
                        label={`${t('pages.orgFornecedora.Score')} Engajados*`}
                        {...register('CdScoreAtivos')}
                        sx={{ marginTop: '1rem', marginBottom: '0' }}
                        inputProps={{ maxLength: 10 }}
                      />
                      {errors?.CdScoreAtivos?.type && <InputError type={errors.CdScoreAtivos.type} field='CdScoreAtivos' />}
                    </Grid>
                    <FormControlLabel control={<Checkbox checked={isNaoEngajado} onChange={(e) => handleChangeNaoEngajados(e)}/>} label="Não engajados" />
                    <Grid item xs={6} width={300}>
                      <TextField
                        error={errors?.CdScoreInativos?.type ? true : false}
                        fullWidth
                        disabled={!isNaoEngajado || isSubmitting || isLoading || (!hasPermitionUpdate && novo)}
                        id='CdScoreInativos'
                        type='text'
                        label={`${t('pages.orgFornecedora.Score')} Não engajados*`}
                        {...register('CdScoreInativos')}
                        sx={{ marginTop: '1rem', marginBottom: '0' }}
                        inputProps={{ maxLength: 10 }}
                      />
                      {errors?.CdScoreInativos?.type && <InputError type={errors.CdScoreInativos.type} field='CdScoreInativos' />}
                    </Grid>
                  </FormGroup>
                </CardContent>
              </Card>
              :
              ''
          }
                    

        </Box>

        <ConfirmacaoModal
          open={openConfirmacao}
          title={titleConfirmacao}
          message={messageConfirmacao}
          onClose={() => setOpenConfirmacao(false)}
          onConfirm={() => confirmDelete()}
        />

        <AlteracaoStatusModalOrgForn
          open={openAlterarStatus}
          status={statusAlteracao}
          alterado={statusAlteracao !== `${orgForn.StatusOrgForn}`}
          onChangeStatus={(status) => setStatusAlteracao(status)}
          onClose={() => {setStatusAlteracao(`${orgForn.StatusOrgForn}`);setOpenAlterarStatus(false);}}
          onSave={handleAlterarStatus}
          // onSave={alterarStatus}
        />
      </Box>
      {(isLoading || isSubmitting) && (<Box sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <CircularProgress />
      </Box>)}
    </LayoutBaseDePagina >
  );
};
